import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { type ICreditUsageSourceItem } from 'entities/Analytics/api/types'

export class Source {
  id: string
  name: string | null
  type: string
  status: string
  messages: number
  credits: number
  entity_id?: number
  is_deleted?: boolean

  constructor(data: ICreditUsageSourceItem) {
    this.id = nanoid()
    this.name = data.source_name
    this.type = data.source_group_label
    this.status = data.status
    this.messages = data.count_records
    this.credits = Number(data.spent_credits)
    this.is_deleted = data.is_deleted

    makeAutoObservable(this)
  }
}
